import { render, staticRenderFns } from "./volunteer-form.vue?vue&type=template&id=06647d12"
import script from "./volunteer-form.vue?vue&type=script&lang=js"
export * from "./volunteer-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports